export enum LoyaltyProgram {
    MySephora = 'MySephora',
}
